export type Trial = {
  endsAt: string;
  daysLeft: number;
} | null;

export function computeTrialFromEndDate(trialEndDate: Date): Trial {
  const now = new Date();
  const diffMs = trialEndDate.getTime() - now.getTime();
  const diffDays = Math.max(0, Math.ceil(diffMs / (24 * 60 * 60 * 1000)));

  return {
    endsAt: trialEndDate.toISOString(),
    daysLeft: diffDays,
  };
}

export function computeTrial(createdAt: string, trialDays: number): Trial {
  const createdDate = new Date(createdAt);
  if (isNaN(createdDate.getTime())) {
    return null;
  }

  const trialEndDate = new Date(createdDate);
  trialEndDate.setDate(trialEndDate.getDate() + trialDays);

  return computeTrialFromEndDate(trialEndDate);
}

export function computeTrialFromExpiry(trialExpires: string): Trial {
  const trialEndDate = new Date(trialExpires);
  if (isNaN(trialEndDate.getTime())) {
    return null;
  }

  return computeTrialFromEndDate(trialEndDate);
}
